import api from '../api/axios';
import { API_ENDPOINTS } from './api.config';

const chatService = {
  // Start a new chat consultation
  startChatConsultation: async (doctorId, message) => {
    try {
      const response = await api.post(API_ENDPOINTS.CONSULTATIONS.START_CHAT, {
        doctor_id: doctorId,
        message: message
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to start consultation' };
    }
  },

  // Get all user consultations
  getUserConsultations: async () => {
    try {
      const response = await api.get(API_ENDPOINTS.CONSULTATIONS.CONSULTATIONS);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to fetch consultations' };
    }
  },

  // Get consultation messages with pagination
  getConsultationMessages: async (consultationId, page = 1, pageSize = 50, skipCache = false) => {
    try {
      const response = await api.get(API_ENDPOINTS.CONSULTATIONS.MESSAGES(consultationId), {
        params: { page, page_size: pageSize },
        skipCache: skipCache // Skip cache when fetching after sending a message
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to fetch messages' };
    }
  },

  // Send message in consultation
  sendMessage: async (consultationId, message) => {
    try {
      const response = await api.post(API_ENDPOINTS.CONSULTATIONS.SEND_MESSAGE(consultationId), {
        message: message
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to send message' };
    }
  },

  // Get consultation info
  getConsultationInfo: async (consultationId) => {
    try {
      const response = await api.get(API_ENDPOINTS.CONSULTATIONS.INFO(consultationId));
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to fetch consultation info' };
    }
  },

  // End consultation
  endConsultation: async (consultationId) => {
    try {
      const response = await api.post(API_ENDPOINTS.CONSULTATIONS.END(consultationId));
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to end consultation' };
    }
  }
};

export default chatService;
